import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Field, Formik, Form as FormFormik } from 'formik';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconClear from '@material-ui/icons/Clear';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './styles';
import * as Yup from 'yup';

import { OutlineTextField } from '../../../FormikCustoms';

const SignupSchema = Yup.object().shape({
  barcode: Yup.string()
    .min(30, 'O código barras requer no mínimo 30 números')
    .required('O código de barras é obrigatório'),
});

const Form = ({ onSubmit, onClear, clearValue }) => {

  const classes = useStyles();
  const [textBarcode, setTextBarcode] = useState('');
  const textFieldRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [buttonSize, setButtonSize] = useState(0);
  const buttonRef = useRef(null);

  useEffect(() => {
    const { clientHeight, clientWidth } = buttonRef.current;
    setButtonSize(Math.min(clientHeight, clientWidth));
  }, []);

  useEffect(() => {
    if (clearValue) {
      clearInput();
    }
  }, [clearValue]);

  const clearInput = () => {
    if (textFieldRef?.current) {
      const input = textFieldRef.current.querySelector('input');
      input.value = '';
      input.focus();
    }
  };

  const onSubmitWithLoading = useCallback(async (barcode) => {
    setLoading(true);
    try {
      await onSubmit(barcode);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }

  }, [setLoading, onSubmit]);

  const handleConfirmBarcode = async (errorCallback) => {
    try {
      await onSubmitWithLoading(textBarcode);
    } catch (e) {
      errorCallback();
    }
  };

  const handleClearInput = (setValues) => {
    clearInput();
    setValues({});
    onClear();
  };

  const handleFieldTextBarcode = useCallback((value) => {
    setTextBarcode(value);
  }, [setTextBarcode]);

  const onSubmitEnter = useCallback(async (event, errorCallback) => {
    if (event.key === 'Enter') {
      try {
        await onSubmitWithLoading(event.target.value);
      } catch (e) {
        errorCallback();
      }
    }
  }, [onSubmitWithLoading]);

  return (
    <Formik
      initialValues={{
        barcode: '',
      }}
      validateOnMount
      validationSchema={SignupSchema}
      onSubmit={(_values, { setValues, _setSubmiting }) => {
        handleConfirmBarcode(() => setValues({}));
      }}
    >
      {({ submitForm, isSubmiting, setValues }) => (
        <FormFormik>
          <Grid container spacing={3}>
            <Grid item md={10} xs={10}>
              <Field
                innerRef={textFieldRef}
                component={OutlineTextField}
                disabled={false}
                placeholder='Insira o código'
                size="small"
                name="barcode"
                mask="999999999999999999999999999999"
                autoFocus
                className={classes.inputFieldBarcode}
                onKeyDown={(e) => onSubmitEnter(e, () => setValues({}))}
                onPaste={(event) => handleFieldTextBarcode(event.clipboardData.getData('Text'))}
                onChange={(event) => handleFieldTextBarcode(event.target.value)}
                InputProps={
                  {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="barcode clear"
                          onClick={() => handleClearInput(setValues)}
                          edge="end"
                        >
                        {textBarcode.length >= 0 && <IconClear />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }
                }
              />
            </Grid>

            <Grid item md={2} xs={2}>
              <Button
                ref={buttonRef}
                color="primary"
                variant="contained"
                size="large"
                className={[classes.btns, loading ? '' : classes.btnSearchBarcode]}
                disabled={isSubmiting || loading}
                onClick={submitForm}
              >
                {loading ? <CircularProgress size={0.7 * buttonSize} /> : 'Pesquisar'}
              </Button>
            </Grid>
          </Grid>
        </FormFormik>
      )}
    </Formik>
  );
};

export default Form;
